// extracted by mini-css-extract-plugin
module.exports = {"quiz":"style__quiz__5nl+p"};